import { OptInKeuze } from "./TypeScriptModels";

export default {
  Autobedrijf: {
    Auto: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    MerkModel: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    Bedrijf: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    Overig: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    Enquetes: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    }
  },
  BedrijfsGroep: {
    Auto: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    MerkModel: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    Bedrijf: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    Overig: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    },
    Enquetes: {
      Messenger: OptInKeuze.Onbekend,
      Email: OptInKeuze.Onbekend,
      Telefoon: OptInKeuze.Onbekend,
      Post: OptInKeuze.Onbekend
    }
  }
};
